import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Capacitor } from "@capacitor/core";

import App from "./App";
import "./i18n";
import { AuthProvider } from "./providers/AuthProvider";
import { ToastProvider } from "./providers/ToastProvider";
import { NetworkStatusProvider } from "./providers/NetworkStatusProvider";
import { initializeClientErrorReporter } from "./services/clientErrorReporter";
import "./tailwind.css";

if (Capacitor.isNativePlatform()) {
  document.body.classList.add("native-app");
}

initializeClientErrorReporter();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element '#root' not found");
}

const reactRoot = ReactDOM.createRoot(rootElement);

reactRoot.render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <NetworkStatusProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </NetworkStatusProvider>
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>
);

requestAnimationFrame(() => {
  const loader = document.getElementById("initial-loader");
  if (!loader) {
    return;
  }

  loader.classList.add("initial-loader--hidden");
  loader.addEventListener(
    "transitionend",
    () => {
      loader.remove();
    },
    { once: true }
  );

  window.setTimeout(() => {
    if (loader.parentElement) {
      loader.remove();
    }
  }, 600);
});
